import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2'; import $ from "jquery";
import {
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';
import Select from "react-select";

const SupplyChainLoading = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");
  let season_start = localStorage.getItem("season_start");
  let season_end = localStorage.getItem("season_end");


  const start = parseInt(season_start.slice(0, 4), 10);
  const end = parseInt(season_end.slice(0, 4), 10);

  const years = [];

  for (let y = start; y <= end; y++) {
    const inner_year = {  // Changed from [] to {}
      value: y,
      label: y,
      key: y
    };

    years.push(inner_year);
  }
  console.log(years); // [2025, 2026, 2027, 2028]

  console.log(season_start);
  console.log(season_end);

  let para = { season_id: season_id };
  useEffect(() => {
    setPermission(FindModuleById(111));
    console.log(permission);

    axios.post(
      "/supply-chain-loading/listing",
      para,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        setData(response.data.data.supply_chain_loading);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const deleteItem = (item) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/supply-chain-loading/delete/${season_id + '-' + item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/supplychain-loadings";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const statusOptions = [
    {
      "id": 1,
      "title": "Draft",
      "color": "white",
      "bg_color": "red",
    },
    {
      "id": 2,
      "title": "In Transit",
      "color": "white",
      "bg_color": "blue",
    },
    {
      "id": 3,
      "title": "Delivered",
      "color": "white",
      "bg_color": "green",
    },
  ];


  const editItem = (item) => {
    window.location.href = "/supplychain-loadings-edit/" + item;
  }



  const changeOrderStatus = (user_id, status, type) => {
    let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/supply-chain-loading/change-status/${season_id + '-' + user_id}/${status}`, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
          .then((response) => {
            console.log(response.data.data.paymentstatus);
            if (response.data.code === 200) {
              $("#status-" + type + "-" + user_id).text(response.data.data.paymentstatus.title);
              $("#status-" + type + "-" + user_id).css('background-color', response.data.data.paymentstatus.bg_color);
              $("#status-" + type + "-" + user_id).css('color', response.data.data.paymentstatus.color);


              axios.post(
                "/supply-chain-loading/listing",
                para,
                {
                  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                }
              )
                .then((response) => {
                  setData(response.data.data.supply_chain_loading);
                })
                .catch((error) => {
                  console.log(error);
                });

              Swal.fire(
                'Success!',
                'Loading Status has been changed Successfully.',
                'success'
              );
              // setTimeout(() => {
              //  // window.location.href = "/orders";
              // }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  const PaymentStatusCell = ({ row }) => (
    <div className="btn-group custom-table-btn-group">
      <button
        type="button"
        className="btn btn-block dropdown-toggle me-1"
        id={`status-production-${row.original.id}`}
        style={{
          backgroundColor: row.original.location_status?.bg_color || 'transparent',
          color: row.original.location_status?.color || 'black',
        }}
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {row.original.location_status?.title || ''}
      </button>
      <div className="dropdown-menu">
        {statusOptions &&
          statusOptions.map((shipp) => (
            <button
              key={shipp.id}
              className="dropdown-item btn btn-block"
              style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
              onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
            >
              {shipp.title}
            </button>
          ))}
      </div>
    </div>
  );

  PaymentStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        location_status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }),
    }).isRequired,
  };
  const LotNumberCell = ({ row }) => {

    return (
      <a href={`/supplychain-loadings-view/${row?.original?.id || ''}`} className="">
        {row?.original?.id?.split('-')[0] || 'N/A'}
      </a>
    );
  };

  // ✅ Define PropTypes inside the function
  LotNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
    }).isRequired,
  };


  const TotalAmountCell = ({ row }) => (
    <div>{Number(row.original.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
  );

  TotalAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        total_amount: PropTypes.number,
      }),
    }),
  };

  const Totaltransport_cost = ({ row }) => (
    <div>{Number(row.original.transport_cost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
  );

  Totaltransport_cost.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        transport_cost: PropTypes.number,
      }),
    }),
  };

  const columns = [
    {
      header: 'Lot Number',
      accessorKey: 'id',
      Cell: LotNumberCell, // Use the separate component
    },


    {
      accessorKey: 'date_of_loading',
      header: 'Date',
    },
    {
      accessorKey: 'po_number',
      header: 'PO Order',
    },



    {
      header: 'Invoice Number',
      accessorKey: 'invoice_number',
    },
    {
      header: 'ETA Date',
      accessorKey: 'eta_date',
    },
    {
      header: 'Location',
      accessorKey: 'location',
    },
    {
      header: 'Customer',
      accessorKey: 'company_name',
    },

    {
      header: 'Transit Supplier',
      accessorFn: (row) => (row.transitsupplier ? row.transitsupplier.name : ''),
    },
    {
      header: 'Loading Status',
      accessorFn: (row) => row.location_status?.title || '',
      Cell: PaymentStatusCell,
    },
    {
      accessorKey: 'truck_number_show',
      header: 'Truck Number',
    },

    {
      accessorKey: 'total_net_weight',
      header: 'Weight',
    },
    // {
    //   accessorKey: 'total_amount',
    //   header: 'Invoice Amount',
    // },
    {
      header: 'Invoice Amount',
      accessorKey: 'total_amount', // Changed from accessorFn
      Cell: TotalAmountCell,
    },
    {
      accessorKey: 'total_boxes',
      header: 'Packaging',
    },
    {
      accessorKey: 'sous_dum',
      header: 'Sous Dum',
    },
    {
      header: 'Transport Cost',
      accessorKey: 'transport_cost', // Changed from accessorFn
      Cell: Totaltransport_cost,
    },

    // {
    //   accessorKey: 'transport_cost',
    //   header: 'Transport Cost',
    // },


    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
    },
  ];


  const [formData, setFormData] = useState({
    year: '',
    season_id: season_id,

  });
  const handleSelectChangeCustomer = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      year: selectedOption?.value || ''
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);
    axios.post(
      "/supply-chain-loading/listing",
      formData,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        setData(response.data.data.supply_chain_loading);
      })
      .catch((error) => {
        console.log(error);
      });
  }



  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    window.open(`${base_url}/supply-chain-loading/listing-excel?${queryString}`, '_blank');
  }



  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Supply Chain Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Supply Chain Loading
                    </li>
                  </ul>
                </div>

              </div>
            </div>
            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                  <div className="row">



                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Year:</label>

                        <Select
                          options={years}
                          name="year"
                          value={years.find(option => option.value === formData.year) || ''}
                          onChange={handleSelectChangeCustomer}  // Simplified
                          isClearable  // Optional: allows clearing the selection
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/supplychain-loadings" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="col-auto mt-4" style={{ float: 'right' }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => downloadExcel()}
                        >
                          <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                        </button>
                        &nbsp;&nbsp;
                        {permission?.add == 1 && (
                          <Link to="/supplychain-loadings-add" className="btn btn-primary me-1" >
                            <i className="fas fa-plus"></i>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                      {permission?.list == 1 && (
                        <MaterialReactTable columns={columns} data={data}
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                          renderRowActionMenuItems={({ row }) => [
                            permission?.update == 1 && (
                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                Edit
                              </MenuItem>
                            ),
                            permission?.delete == 1 && (
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                Delete
                              </MenuItem>
                            ),
                          ]}
                        />

                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplyChainLoading;
